// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tauros_paldea_aqua_breed: PokeData = {
  "id": 10252,
  "name": "tauros-paldea-aqua-breed",
  "height": 14,
  "weight": 1100,
  "base_experience": 172,
  "types": [
    PokeType.FIGHTING,
    PokeType.WATER
  ],
  "api_moves": [
    "double-kick",
    "headbutt",
    "tackle",
    "thrash",
    "tail-whip",
    "rest",
    "scary-face",
    "swagger",
    "close-combat",
    "zen-headbutt",
    "aqua-jet",
    "work-up",
    "wave-crash",
    "raging-bull"
  ],
  "moves": [
    "double-kick",
    "headbutt",
    "tackle",
    "scary-face",
    "close-combat",
    "zen-headbutt",
    "aqua-jet",
    "bubble",
    "aqua-cutter",
    "meteor-assault",
    "coaching",
    "water-spout",
    "bubble-beam"
  ],
  "evolution_chain": {
    "id": 63,
    "item": null,
    "species": [
      {
        "name": "tauros",
        "order": 152,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 112,
    "speed": 137,
    "ability_power": 151
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "paldea"
} as const;
